module.exports = __webpack_public_path__ + "static/media/tf.e251a7e9.svg";